angular.module('picmonicng').factory('SuggestionsResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/suggestions',
      {},
      {
        queryv3: {
          method: 'GET',
          url: '/api/v3/suggestions',
          isArray: false,
          cancellable: true,
        },
      }
    );
  },
]);
